import React from 'react';
import { SearchIcon, BoxIcon, LinkIcon, PaletteIcon } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <SearchIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-198" />,
    title: 'Curate Top Amazon Deals in Seconds',
    description: 'Save hours and find Amazon Deals up to 50% off in our daily-updated deal database to send to your subscribers.',
    image: "/IMAGE1.png",
    objectPosition: 'center top' // Adjusted to align with the top of the box
  }, {
    icon: <BoxIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-199" />,
    title: 'Instant, Pre-Formatted Product Boxes',
    description: 'Select your deal list in Kit and voilà, styled product boxes (image, discount, description, buy button) drop into your draft, no ugly links.',
    image: "/Kit-Image-3.jpg",
    objectPosition: 'center 0%' // Adjusted to show more of the top part
  }, {
    icon: <LinkIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-200" />,
    title: 'Automatic Affiliate Linking & Formatting',
    description: 'Enter your Affiliate ID once - every box carries your code and polished HTML so you never wrestle with link creation or layout.',
    image: "https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/debbab01-79d9-49e0-a766-2a2a9aeb34ad/IMAGE2.png",
    objectPosition: 'center' // Keeping centered position for the new image
  }, {
    icon: <PaletteIcon className="h-6 w-6 text-[#5e60ce]" data-id="element-201" />,
    title: '100% On-Brand Styling',
    description: "Tweak fonts, colors, and spacing right in Kit's editor so your deals look native to your newsletter's design.",
    image: "/Kit-Image-5.jpg"
  }];
  return <section id="features" className="py-20 bg-white" data-id="element-202">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-205">
            Features That Save You Time
          </h2>
          <p className="text-xl text-gray-600" data-id="element-206">
            Everything you need to monetize your newsletter without the hassle.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-207">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden border border-gray-100" data-id="element-208">
              <div className="aspect-[16/9] overflow-hidden" data-id="element-209">
                <img src={feature.image} alt={feature.title} className="w-full h-full object-cover transition-transform duration-300 hover:scale-105" style={{
              objectPosition: feature.objectPosition || 'center'
            }} data-id="element-210" />
              </div>
              <div className="p-6" data-id="element-211">
                <div className="flex items-center mb-4" data-id="element-212">
                  <div className="p-2 rounded-md mr-3" style={{
                backgroundColor: '#f2f1f8'
              }} data-id="element-213">
                    {feature.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900" data-id="element-214">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-gray-600" data-id="element-215">{feature.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}